import { render, staticRenderFns } from "./PairedUnitsComponent.vue?vue&type=template&id=44c809c4&"
import script from "./PairedUnitsComponent.vue?vue&type=script&lang=js&"
export * from "./PairedUnitsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports